import { createIcon } from './createIcon'

export const InfoOutlineIcon = createIcon({
  displayName: 'InfoOutlineIcon',
  viewBox: '0 0 17 17',
  path: [
    <path
      d="M8.39941 14.9167C4.71751 14.9167 1.73274 11.9319 1.73274 8.25001C1.73274 4.56811 4.71751 1.58334 8.39941 1.58334C12.0813 1.58334 15.0661 4.56811 15.0661 8.25001C15.062 11.9302 12.0796 14.9126 8.39941 14.9167ZM3.06608 8.36468C3.09762 11.2988 5.49348 13.6564 8.42777 13.6407C11.3621 13.6248 13.7324 11.2417 13.7324 8.30734C13.7324 5.37301 11.3621 2.98986 8.42777 2.97401C5.49348 2.95832 3.09762 5.31585 3.06608 8.25001V8.36468ZM9.73274 11.5833H7.73274V8.91668H7.06608V7.58334H9.06608V10.25H9.73274V11.5833ZM9.06608 6.25001H7.73274V4.91668H9.06608V6.25001Z"
      fill="currentColor"
    />,
  ],
})
